import React from 'react';
import { arrayOf, shape, string, bool, func } from 'prop-types';
import urls from 'constants/urls';
import { notRequiredAddressSchema as addressSchema } from 'components/Address/util';
import ModalWithCloseButton from 'components/wdx/ModalWithCloseButton';
import HashRoutedSlides from 'components/Address/common/ChooseAddressModal/HashRoutedSlides/HashRoutedSlides';
import AddressBookView from './AddressBookView';
import AddAddressView from './AddAddressView';
import EditAddressView from './EditAddressView';

const chooseAddressModalDefaultPropOnAfterClose = () => {};
const chooseAddressModalDefaultPropOnAfterSelect = () => {};

const ChooseAddressModal = ({
  isOpen = false,
  addAddressTitle = 'Add Address',
  editAddressTitle = 'Edit Address',
  onAfterClose = chooseAddressModalDefaultPropOnAfterClose,
  onAfterSelect = chooseAddressModalDefaultPropOnAfterSelect,
  ukOnlyAddress = false,
  manualOnly = true,
  addresses,
  closeModal,
  pageTitle,
  location,
  showAddAddress,
  hasError,
}) => {
  const afterSelect = data => {
    onAfterSelect(data);
    onAfterClose();
  };
  return (
    <ModalWithCloseButton
      closeModal={() => {
        closeModal(true);
        onAfterClose();
      }}
      fullScreenTransitions
      isOpen={isOpen}
      modalHeadingID="selectAddressModalTitle"
    >
      <HashRoutedSlides location={location}>
        <AddressBookView
          {...{
            pageTitle,
            addresses,
            hash: urls.addressModals.choose,
            onAfterSelect: afterSelect,
            ukOnlyAddress,
            showAddAddress,
            hasError,
          }}
        />
        <AddAddressView
          {...{
            addAddressTitle,
            hash: urls.addressModals.add,
            onAfterSubmit: afterSelect,
            navigateBack: addresses.length !== 0,
            ukOnlyAddress,
            manualOnly,
          }}
        />
        <EditAddressView
          {...{
            editAddressTitle,
            hash: urls.addressModals.edit,
            onAfterSubmit: afterSelect,
            ukOnlyAddress,
            manualOnly,
          }}
        />
      </HashRoutedSlides>
    </ModalWithCloseButton>
  );
};

ChooseAddressModal.propTypes = {
  isOpen: bool,
  addAddressTitle: string,
  editAddressTitle: string,
  addresses: arrayOf(shape(addressSchema)).isRequired,
  pageTitle: string.isRequired,
  closeModal: func.isRequired,
  onAfterClose: func,
  onAfterSelect: func,
  location: shape({
    hash: string.isRequired,
  }).isRequired,
  hasError: bool.isRequired,
  ukOnlyAddress: bool,
  showAddAddress: func.isRequired,
  manualOnly: bool,
};

export default ChooseAddressModal;
